import { Theme } from '@material-ui/core';

export const MuiMenuItem = (theme: Theme): Record<string, unknown> => ({
  root: {
    minWidth: '160px',
    display: 'flex',
    // justifyContent: 'center',
  },
});
